import useSWR, { SWRConfiguration, SWRResponse } from "swr";
import { fetchAllV1Items } from "~/utils/accessController";
import { safelyCamelize } from "~/utils/object";

interface UseV1ListOptions<T> extends SWRConfiguration<T[]> {
  shouldCamelize?: boolean;
}

// SWR hook that returns every item from a v1 list endpoint, with optional camelize for
// resources whose items arrive snake_case on the wire (funding sources)
export const useV1List = <T>(
  url: string | null,
  options: UseV1ListOptions<T> = {}
): SWRResponse<T[]> => {
  const { shouldCamelize, ...swrOptions } = options;
  return useSWR<T[]>(
    url,
    async (listUrl: string) => {
      const items = await fetchAllV1Items<T>(listUrl);
      return shouldCamelize ? safelyCamelize(items, false) : items;
    },
    swrOptions
  );
};
